<template>
  <v-row align="center">
    <v-overlay :value="loading" :opacity="1" :color="'#FFFFFF'">
      <v-progress-circular color="#FFB300" indeterminate size="64"></v-progress-circular>
    </v-overlay>
   

    <div class="col-md-12 home-box" >   
      <MemberGrid></MemberGrid>
    </div>
    <div class="col-md-12 home-tabs-body">     
    </div>
  </v-row>
</template>

<script>

import MemberGrid from "@/components/members/MemberGrid";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "Members",
  components: {
    MemberGrid
  },
  data: function() {
    return {     
    };
  },
  computed: {
    ...mapGetters({     
      loading: "loading",
      profile: "profile"
    })
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");  
  },

  watch: {
   
  },

  methods: {
   
    },   
  
};
</script>
